/* src/views/SkillsView.js */
import { ref, onMounted } from 'vue'
import { Plus, Edit, Trash2, X, Sun, Moon } from 'lucide-vue-next'
import { useThemeStore } from '@/stores/theme'
import Swal from 'sweetalert2'

import { SkillsService } from '@/services/SkillsService'

export default {
  name: 'SkillsView',

  components: {
    Plus, Edit, Trash2, X, Sun, Moon
  },

  setup() {

    const themeStore = useThemeStore()
    const skills = ref([])
    const fetchSkills = async () => {

      try {

        skills.value = await SkillsService.getAll()
      } 
      catch (error) {

        console.error("Errore nel caricamento delle competenze:", error)
      }
    }

    onMounted(() => {

      fetchSkills()
    })

    const isDrawerOpen = ref(false)
    const editingSkill = ref(null)
    const formName = ref('')
    const formDescription = ref('')

    const toggleTheme = () => {

      themeStore.toggleTheme()
    }

    const openDrawer = (skill = null) => {

      if (skill) {

        editingSkill.value = skill
        formName.value = skill.name
        formDescription.value = skill.description
      } 
      else {

        editingSkill.value = null
        formName.value = ''
        formDescription.value = ''
      }
      isDrawerOpen.value = true
    }

    const closeDrawer = () => {

      isDrawerOpen.value = false

      setTimeout(() => {
        editingSkill.value = null
        formName.value = ''
        formDescription.value = ''
      }, 300)
    }

    const saveSkill = async () => {

      if (!formName.value.trim()) return

      const skillData = {
        name: formName.value.trim(),
        description: formDescription.value.trim()
      }

      try {
      
        if (editingSkill.value) {

          await SkillsService.update(editingSkill.value.id, skillData)
        } 
        else {

          await SkillsService.create(skillData)
        }
        await fetchSkills()
        closeDrawer()
      } 
      catch (error) {

        Swal.fire({
            title: 'Errore',
            text: "Errore durante il salvataggio della competenza",
            icon: 'error',
            confirmButtonText: 'Chiudi'
        })
      }
    }

    const deleteSkill = async (id) => {
      
      if (confirm('Sei sicuro di voler eliminare questa competenza?')) {
        
        try {
        
          await SkillsService.delete(id)
          await fetchSkills()
        } 
        catch (error) {

          Swal.fire({
              title: 'Errore',
              text: "Errore durante l'eliminazione della competenza",
              icon: 'error',
              confirmButtonText: 'Chiudi'
          })
        }
      }
    }

    return {
      themeStore,
      toggleTheme,
      skills,
      isDrawerOpen,
      editingSkill,
      formName,
      formDescription,
      openDrawer,
      closeDrawer,
      saveSkill,
      deleteSkill
    }
  }
}